<div class="flex flex-row gap-2 items-center w-full">
  <div class="rounded-full aspect-square border-1 h-6 flex aligns-center justify-center"
       style="border-color: var(--color-neutral-300)">
    <img alt="Icon" class="h-5" src="/assets/icons/compliance/favorite.png">
  </div>
  <h5>{{ group?.name || 'Grupo' }}</h5>
  <div class="ml-auto flex my-auto flex-row gap-2 items-center">
    <span class="lg:hidden xl:block cd-text-b3 my-auto">{{ isEditable ? 'Editable' : 'Vista' }}</span>
    <core-switch [(checked)]="isEditable" [disabled]="isSaving"/>
  </div>
</div>

<div class="flex flex-col xl:flex-row gap-2 items-center w-full">

  <div class="form-control flex-1 w-full">
    <label class="text-neutral-900" for="name">Descripción</label>
    @if (isEditable) {
      <textarea (blur)="handleBlur()" [(ngModel)]="description" [disabled]="isSaving" id="description" placeholder="Sin descripción" rows="3"></textarea>
    } @else {
      <div class="group-widget-static-field group-widget-static-field-area">
        <span class="cd-text-b4 text-neutral-700">{{ group?.description || 'Sin descripción' }}</span>
      </div>
    }
  </div>

  <div class="form-control flex-1 w-full">
    <label class="text-neutral-900" for="name">Función</label>
    @if (isEditable) {
      <textarea (blur)="handleBlur()" [(ngModel)]="roleFunction" [disabled]="isSaving" id="group-function" placeholder="Sin función definida" rows="3"></textarea>
    } @else {
      <div class="group-widget-static-field group-widget-static-field-area">
        <span class="cd-text-b4 text-neutral-700">{{ group?.function || 'Sin función definida' }}</span>
      </div>
    }
  </div>

</div>

<div class="flex flex-col xl:flex-row gap-2 w-full">

  <div class="form-control flex-1 w-full">
    <label class="text-neutral-900" for="role">Asociar empleados</label>
    @if (isEditable) {
      <core-select
        [(ngModel)]="selectedEmployeeId"
        [disabled]="isSaving || !availableEmployeeOptions.length"
        [options]="availableEmployeeOptions"
        placeholder="Selecciona empleado"/>
      <button (click)="addEmployee()" [disabled]="isSaving || !selectedEmployeeId" class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem] mt-2"
              style="border-radius: 0.5rem;padding: 0.5rem 1rem" type="button">
        <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/plus-square.svg">
        <span class="hidden lg:block cd-text-md truncate capitalize">Agregar</span>
      </button>
    } @else {
      <div class="group-widget-static-field group-widget-static-select">
        <span class="cd-text-b4 text-neutral-500">Disponible al activar edición</span>
      </div>
    }
  </div>

  <div class="form-control flex-1 w-full">
    <label class="text-neutral-900" for="role">Encargado</label>
    @if (isEditable) {
      <core-select
        (ngModelChange)="handleManagerChange($event)"
        [(ngModel)]="managerId"
        [disabled]="isSaving || !employees.length"
        [options]="managerOptions"
        placeholder="Selecciona encargado"/>
    } @else {
      <div class="group-widget-static-field group-widget-static-select">
        <span class="cd-text-b4 text-neutral-700">{{ group?.manager?.name || 'Sin encargado' }}</span>
      </div>
    }
  </div>

</div>

@if (feedbackMessage) {
  <div
    [class.group-widget-feedback-error]="feedbackTone === 'error'"
    [class.group-widget-feedback-success]="feedbackTone === 'success'"
    class="group-widget-feedback">
    <span class="cd-text-b4">{{ feedbackMessage }}</span>
  </div>
}

<div class="flex flex-col gap-2">
  <span class="cd-text-b2 text-neutral-900">Empleados asociados</span>

  <div class="flex flex-row flex-wrap gap-3 w-full">
    @for (member of employees; track member.id) {
      <div class="py-1 px-3 rounded-[1rem] flex flex-row items-center bg-neutral-200">
        <span class="cd-text-b4 text-neutral-800">{{ member.name }}</span>
        @if (isEditable) {
          <button (click)="removeEmployee(member.id)" [disabled]="isSaving" class="btn btn-neutral-text !px-1 !py-1 ml-1" type="button">
            <img alt="Quitar" class="h-4 filter-neutral-800" src="/assets/icons/feather/x.svg"/>
          </button>
        }
      </div>
    } @empty {
      <span class="cd-text-b4 text-neutral-500">Sin empleados asociados.</span>
    }
    @if (isSaving) {
      <div class="group-member-skeleton animate-pulse"></div>
    }
  </div>
</div>

<div class="flex justify-end mt-auto">
  <button (click)="openDetail()" class="btn btn-primary-soft !px-3 !py-2" type="button">
    Ver detalle
  </button>
</div>
